import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgTwitterLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 512 512",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#twitter_path0_fill",
			fill: "#1DA1F2"
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#twitter_path1_fill",
			transform: "translate(96 126.018)",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("path", {
			id: "twitter_path0_fill",
			d: "M512 256c0 141.385-114.615 256-256 256S0 397.385 0 256 114.615 0 256 0s256 114.615 256 256z"
		}), /* @__PURE__ */ _jsx("path", {
			id: "twitter_path1_fill",
			d: "M100.634 260.017c120.755 0 186.803-100.045 186.803-186.804 0-2.841 0-5.67-.192-8.486A133.589 133.589 0 0 0 320 30.743a131.042 131.042 0 0 1-37.709 10.33 65.88 65.88 0 0 0 28.864-36.314 131.57 131.57 0 0 1-41.689 15.936 65.717 65.717 0 0 0-111.885 59.878A186.39 186.39 0 0 1 22.272 11.978 65.703 65.703 0 0 0 42.598 99.62 65.164 65.164 0 0 1 12.8 91.402v.832a65.675 65.675 0 0 0 52.672 64.359 65.549 65.549 0 0 1-29.645 1.126 65.73 65.73 0 0 0 61.338 45.594 131.743 131.743 0 0 1-81.536 28.16A133.617 133.617 0 0 1 0 230.525a185.862 185.862 0 0 0 100.634 29.44"
		})] })
	]
});
export default SvgTwitterLogo;
